import { Injectable } from '@angular/core';

import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';

import { combineLatest, EMPTY, Observable, throwError } from 'rxjs';
import { catchError, concatMap, first } from 'rxjs/operators';


@Injectable() // do not use providedIn because multi-provided
export class AuthHttpInterceptor implements HttpInterceptor {

    constructor(private authService: any) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add withCredentials to ensure that auth cookies are sent on CORS requests
        req = req.clone({
            withCredentials: true
        });
        if (req.url.startsWith(this.authService.apiUrl)) {
            return this.authService.tokenTrigger.pipe(
                first(),
                concatMap(accessToken => {
                    if (accessToken) {
                        const headers: any = {'Authorization': `Bearer ${accessToken}`};
                        req                = req.clone({setHeaders: headers});
                    }
                    return next.handle(req).pipe(
                        // catchError((error: HttpErrorResponse) => {
                        //     // Do something about token expiration
                        // })
                    );
                })
            );
        } else {
            return next.handle(req);
        }
    }
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/authentication/classes/auth-http-interceptor.ts